import { ActivatedRouteSnapshot, BaseRouteReuseStrategy, DetachedRouteHandle } from '@angular/router';

/**
 * @author: scalero1
 * @subject Clase extraída del ejemplo propuesto en el artículo: https://tacettinsertkaya.medium.com/angular-routereusestrategy-335686fa7ad8
 * con el objetivo de solucionar el deprecated de la instrucción:
 *          this.router.routeReuseStrategy.shouldReuseRoute = () => false;
 */
export class AppRouteReuseStrategy implements BaseRouteReuseStrategy {
    shouldDetach(route: ActivatedRouteSnapshot): boolean {
        return false;
    }
    store(route: ActivatedRouteSnapshot, detachedTree: DetachedRouteHandle): void {}
    shouldAttach(route: ActivatedRouteSnapshot): boolean {
        return false;
    }
    retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
        return null;
    }
    public shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
        return future.routeConfig === curr.routeConfig || future.data.reuseComponent;
    }
}
